const styles = theme => ({
  root: {
    position: 'relative',
    display: 'block',
    border: 'none',
    margin: 0,
    padding: 0,
    boxShadow: 'none',
    textShadow: 'none'
  },
  link: {
    border: 'none',
    outline: 'none',
    userSelect: 'none'
  },
  kicker: {
    display: 'block',
    margin: [0, 0, 8],
    fontFamily: theme.typography.secondary,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.22em',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: theme.color.secondary.main
  },
  title: {
    display: 'block',
    position: 'relative',
    fontFamily: theme.typography.primary,
    fontSize: 18.33,
    fontWeight: 400,
    letterSpacing: '0.04em',
    lineHeight: 1,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    color: theme.color.heading.main
  },
  svg: {
    display: 'block',
    margin: [10, 0, 0],
    border: 'none',
    padding: 0,
    width: '100%',
    opacity: 0,
    filter: `drop-shadow(0 0 1.5px ${theme.color.secondary.main})`
  },
  path: {
    fill: 'none',
    strokeWidth: 3,
    stroke: theme.color.secondary.main,
    transition: `stroke ${theme.animation.time}ms ease-out`
  },
  hover: {
    '&:hover': {
      '& $path': {
        stroke: theme.color.secondary.main
      }
    }
  }
});

export { styles };
